import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { ChevronDown, CloseIcon, FacebookIcon, InstagramIcon, MenuIcon, YouTubeIcon } from './Icons'

type NavItem = {
  label: string
  to: string
  children?: { label: string; to: string }[]
}

const navItems: NavItem[] = [
  { label: 'الرئيسية', to: '/' },
  { label: 'البيت المحمدي', to: '/البيت-المحمدي' },
  {
    label: 'المجمع العلمي',
    to: '/المجمع-العلمي',
    children: [
      { label: 'أكاديمية أهل الصفة', to: '/أكاديمية-أهل-الصفة-لدراسات-التصوف' },
      { label: 'المجالس المحمدية', to: '/المجالس-المحمدية' },
      { label: 'المجالس الحديثية', to: '/المجالس-الحديثة' },
    ],
  },
  {
    label: 'الإمام الرائد',
    to: '/الإمام-الرائد',
    children: [
      { label: 'الإمام الرائد', to: '/الإمام-الرائد' },
      { label: 'كتب الإمام الرائد', to: '/كتب-الإمام-الرائد' },
    ],
  },
  { label: 'د. محمد مهنا', to: '/د-محمد-مهنا' },
]

const topLinks = [
  { label: 'الطريقة المحمدية الشاذلية', to: '/الطريقة-المحمدية-الشاذلية' },
  { label: 'أكاديمية أهل الصفة لدراسات التصوف', to: '/أكاديمية-أهل-الصفة-لدراسات-التصوف' },
  { label: 'مجلة أهل الصفة لدراسات التصوف', to: 'https://ahlalsuffa.com/index.php/asshs/index', external: true },
]

export function Header() {
  const [open, setOpen] = useState(false)
  const [expanded, setExpanded] = useState<string | null>(null)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setOpen(false)
    setExpanded(null)
  }, [location.pathname])

  useEffect(() => {
    const updateHeaderState = () => setScrolled(window.scrollY > 18)
    updateHeaderState()
    window.addEventListener('scroll', updateHeaderState, { passive: true })
    return () => window.removeEventListener('scroll', updateHeaderState)
  }, [])

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="topbar">
        <div className="shell topbar-inner">
          <nav className="top-links" aria-label="روابط المؤسسة">
            {topLinks.map((item) => item.external
              ? <a key={item.label} href={item.to} target="_blank" rel="noreferrer">{item.label}</a>
              : <Link key={item.label} to={item.to}>{item.label}</Link>)}
          </nav>
          <div className="top-socials" aria-label="حسابات التواصل الاجتماعي">
            <a href="https://www.facebook.com/albeitalmohamedi/" target="_blank" rel="noreferrer"><FacebookIcon /> <span>فيسبوك</span></a>
            <a href="https://youtube.com/@beitmohamadi?si=zTHDxQePFnCS2LAL" target="_blank" rel="noreferrer"><YouTubeIcon /> <span>يوتيوب</span></a>
            <a href="https://www.instagram.com/albeitalmohamedi?igsh=YzJpNmIzZ2Y2c21z" target="_blank" rel="noreferrer"><InstagramIcon /> <span>انستجرام</span></a>
          </div>
        </div>
      </div>

      <div className="shell nav-row">
        <Link className="brand" to="/" aria-label="البيت المحمدي — الرئيسية">
          <img src="/assets/media/2025/11/logo_orig.png" alt="البيت المحمدي للتصوف" />
        </Link>

        <button className="menu-toggle" type="button" aria-expanded={open} aria-label={open ? 'إغلاق القائمة' : 'فتح القائمة'} onClick={() => setOpen(!open)}>
          {open ? <CloseIcon /> : <MenuIcon />}
        </button>

        <nav className={`main-nav ${open ? 'is-open' : ''}`} aria-label="القائمة الرئيسية">
          {navItems.map((item) => (
            <div className={`nav-item ${item.children ? 'has-submenu' : ''}`} key={item.label}>
              <NavLink to={item.to} end={item.to === '/'}>{item.label}</NavLink>
              {item.children && (
                <>
                  <button type="button" className="submenu-toggle" aria-label={`عرض قائمة ${item.label}`} aria-expanded={expanded === item.label} onClick={() => setExpanded(expanded === item.label ? null : item.label)}>
                    <ChevronDown />
                  </button>
                  <div className={`submenu ${expanded === item.label ? 'is-expanded' : ''}`}>
                    {item.children.map((child) => <Link key={child.label} to={child.to}>{child.label}</Link>)}
                  </div>
                </>
              )}
            </div>
          ))}
        </nav>
      </div>
    </header>
  )
}
